import Vue from 'vue'
import clusterStrategy from './datavis/clusterstrategy'
import MapConstants from '../common/MapConstants'
import * as R from 'ramda'

class MapActions {
  addCircleRender (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    // this.removeLayer(options.mapKey, options.layer);
    options.map = map
    clusterStrategy._addCircleRender(options, style)
  }
  addCustomSymbol (path, width = 15, height = 15) {
    const img = new Image(width, height)
    return new Promise((resolve, reject) => {
      if (!R.is(String, path)) { reject(new Error(`Esperado o caminho do arquivo: path`)) }
      img.onload = () => resolve(img)
      img.onerror = reject
      img.src = path
    })
  }
  addFillRender (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    // this.removeLayer(options.mapKey, options.layer);
    options.map = map
    clusterStrategy._addFillRender(options, style)
  }
  async addUserDrawRender (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    options.map = map
    await clusterStrategy._addUserDrawRender(options, style)
  }
  addHeatmapRender (options, clusterStyle, heatmapStyle) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    // this.removeLayer(options.mapKey, options.layer);
    options.map = map
    clusterStrategy._addHeatmapRender(options, clusterStyle, heatmapStyle)
  }
  addImage (mapKey, id, image, options = {}) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa')
    if (!R.is(String, mapKey)) throw new Error('Esperada uma String: mapKey')
    if (!R.is(String, id)) throw new Error('Esperada uma String: id')
    const map = this._restoreMap2(mapKey).mapObject
    map.addImage(id, image, options)
  }
  addLabelRender (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    options.map = map
    clusterStrategy._addLabelRender(options, style)
  }
  addSymbolRender (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    options.map = map
    clusterStrategy._addSymbolRender(options, style)
  }
  addPointTheme (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!style) throw new Error('Esperado o estilo do layer target')
    const map = this.restoreMap(options.mapKey)
    // this.removeLayer(options.mapKey, options.layer)
    options.map = map
    clusterStrategy._addPointThemeRender(options, style)
  }
  addPolygonTheme (options, style) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!style) throw new Error('Esperado o estilo do layer target')
    const map = this.restoreMap(options.mapKey)
    // this.removeLayer(options.mapKey, options.layer)
    options.map = map
    clusterStrategy._addPolygonThemeRender(options, style)
  }
  addLayer (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    let map = this.restoreMap(options.mapKey)
    options.map = map

    switch (options.datavis.type) {
      case 'fill':
      case 'cluster':
      case 'heatmap':
      case 'circle':
      case 'symbol':
      case 'hexagon':
      case 'square':
      case 'line':
        let options2 = {
          'mapKey': options.mapKey,
          'pk': options.pk,
          'schema': options.schema,
          'table': options.table,
          'layer': options.layer,
          'parent': options.parent,
          'tileSet': options.tileSet,
          'sourceId': options.sourceId,
          'beforeId': options.beforeId,
          'layerId': options.layerId,
          'where': options.hasOwnProperty('where') ? options.where : null,
          'environment': options.environment,
          'maxFeatures': options.maxFeatures,
          'featureCount': options.featureCount,
          'datavis': options.datavis,
          'sampleRate': 100000,
          'enabled': true,
          'userDraw': options.userDraw,
          'frontier': options.frontier ? true : false,
          'extent': 128,
          'clusterOptions': {
            'flyTo': true,
            'showInfo': true,
            'clusterRadius': 50,
            'minZoom': 0,
            'maxZoom': (options.where != null ? 12 : 15)
          }
        }
        clusterStrategy.append(map, options2)
        break
      default:
        throw new Error(`Tipo de DataViz não tratado: ${options.datavis}`)
    }
  }
  hasAnyType (options) {
    const map = this.restoreMap(options.mapKey)
    return clusterStrategy.anyLayerType(map, options.layerId)
  }
  hasImage (mapKey, id) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa')
    if (!R.is(String, mapKey)) throw new Error('Esperada uma String: mapKey')
    if (!R.is(String, id)) throw new Error('Esperada uma String: id')
    const map = this._restoreMap2(mapKey).mapObject
    return map.hasImage(id)
  }
  changeBaseLayer (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new new Error('Esperado o identificador do mapa: mapKey')()
    if (!R.hasIn('layer', options)) throw new new Error('Esperado o identificador do layer: layer')()
    try {
      const map = this.restoreMap(options.mapKey)
      map.setStyle('mapbox://styles/mapbox/' + options.layer + '-v11')
    } catch (e) {
      console.log(e)
    }
  }
  changePaintProperty (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')
    if (!R.hasIn('key', options)) throw new Error('Esperado o nome da propriedade: key')
    if (!R.hasIn('value', options)) throw new Error('Esperado o valor da propriedade: value')
    let map = this.restoreMap(options.mapKey)

    if (map.getLayer(options.layerId) != null) {
      try {
        map.setPaintProperty(options.layerId, options.key, options.value)
      } catch (e) {
        console.error(`Falhou -> ${options.layerId} -> ${options.key} -> ${options.value}`)
      }
    }
  }
  changeLayoutProperty (options) {
    // layerId, key, value
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')
    if (!R.hasIn('key', options)) throw new Error('Esperado o nome da propriedade: key')
    if (!R.hasIn('value', options)) throw new Error('Esperado o valor da propriedade: value')
    let map = this.restoreMap(options.mapKey)

    if (map.getLayer(options.layerId) != null) {
      try {
        map.setLayoutProperty(options.layerId, options.key, options.value)
      } catch (e) {
        console.error(`Falhou -> ${options.layerId} -> ${options.key} -> ${options.value}`)
      }
    }
  }
  clearMap (mapKey) {
    let map = this.restoreMap(mapKey)
    clusterStrategy.cleanMap(map)
  }
  createCluster (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')()
    let map = this.restoreMap(options.mapKey)
    clusterStrategy.append(map, options)
  }
  /**
   * Get the nearest layer
   *
   * @async
   * @function findNearestActive
   * @param {Array} projectLayers - Coleção de camadas que compõem o projeto
   * @param {Number} index - Índice da camada target
   * @return {Promise<json>} The json with the nearest layer
   */
  findNearestActive (projectLayers, index) {
    if (!projectLayers) throw new Error('Esperada uma coleção de layers')
    if (!index) throw new Error('Esperado o índice do layer target')
    if (!Array.isArray(projectLayers)) throw new Error('Esperada uma coleção: projectLayers')
    if (projectLayers.length === 0) throw new Error('A coleção não pode estar vazia: projectLayers')

    try {
      let layers = []
      const refLayer = projectLayers.find(x => x.order === index).object
      let nearestLayer = {layer: null, reverse: false, mapLayerId: ''}

      projectLayers.forEach(function (layer) {
        if (!layer.isVisible) return
        if (layer.object.objectid === refLayer.objectid) return
        layers.push({
          objectid: layer.object.objectid,
          position: layer.object.position
        })
      })

      if (layers.length === 0) return nearestLayer

      layers.sort((a, b) => a.position - b.position)

      const maxPosition = Math.max.apply(Math, layers.map(function (o) {
        return o.position
      }))
      const minPosition = Math.min.apply(Math, layers.map(function (o) {
        return o.position
      }))
      const x = index >= maxPosition ? layers.find(x => x.position === maxPosition) : layers.find(x => x.position <= index)
      const y = index < minPosition ? layers.find(x => x.position === minPosition) : layers.find(x => x.position > index)

      if (x !== undefined) {
        const rObject = projectLayers.find(l => l.object.objectid === x.objectid)
        const beforeDataViz = rObject.object.layer.jbData.config.datavis.type || 'cluster'
        const beforeId = `${beforeDataViz}-${rObject.object.layer.gdIdEvent}`
        nearestLayer.layer = rObject.object.layer
        nearestLayer.mapLayerId = beforeId
      } else if (y !== undefined) {
        const rObject = projectLayers.find(l => l.object.objectid === y.objectid)
        const beforeDataViz = rObject.object.layer.jbData.config.datavis.type || 'cluster'
        const beforeId = `${beforeDataViz}-${rObject.object.layer.gdIdEvent}`
        nearestLayer.layer = rObject.object.layer
        nearestLayer.mapLayerId = beforeId
        nearestLayer.reverse = true
      }
      return nearestLayer
    } catch (e) {
      console.log(e)
    }
  }
  closestValue (array, value) {
    let result, lastDelta

    array.some(function (item) {
      var delta = Math.abs(value - item.order)
      if (delta >= lastDelta) {
        return true
      }
      result = item
      lastDelta = delta
    })
    return result
  }
  hasColumn (options = {}) {
    const features = this.querySourceFeatures(options)
    if (features.length === 0) return false
    let founded = false
    for (let i = 0; i < features.length; i++) {
      if (Object.hasOwn(features[i].properties, options.columnName)) {
        founded = true
        break
      }
    }
    return founded
  }
  /**
   * Get the nearest layer
   *
   * @async
   * @function findNearestLayer
   * @param {Array} projectLayers - Coleção de camadas que compõem o projeto
   * @param {Number} index - Índice da camada target
   * @param {String} classType - Tipo de classe da camada
   * @return {Promise<json>} The json with the nearest layer
   */
  findNearestLayer (projectLayers, index, classType) {
    if (!projectLayers) throw new Error('Esperada uma coleção de layers')
    // if (!index) throw new Error("Esperado o índice do layer target")
    if (!classType) throw new Error('Esperado o tipo de classe do layer')
    if (!Array.isArray(projectLayers)) throw new Error('Esperada uma coleção: projectLayers')
    if (projectLayers.length === 0) throw new Error('A coleção não pode estar vazia: projectLayers')

    const movedLayer = projectLayers[index]
    const visibleLayers = projectLayers.filter(x => x.isVisible === true && x.objectid !== movedLayer.objectid)
    if (visibleLayers.length === 0) return {layer: null, reverse: false, mapLayerId: '', isCluster: false}
    try {
      // const maxPosition = Math.max.apply(Math, visibleLayers.map(function (o) { return o.order }))
      // const minPosition = Math.min.apply(Math, visibleLayers.map(function (o) { return o.order }))
      // const nearestBelow = (input, lookup) => lookup.reduce((prev, curr) => input >= curr.order ? curr : prev)
      const nearestValue = (input, lookup) => lookup.reduce((prev, curr) => (Math.abs(prev.order) > Math.abs(curr.order - input) ? curr.order - input : prev.order), Infinity) + input
      // const up = nearestBelow(movedLayer.order, visibleLayers)
      // const up = visibleLayers.length === 1 ? visibleLayers.find(x => x.order < movedLayer.order) : visibleLayers.find(x => x.order === minPosition)
      // const down = visibleLayers.length === 1 ? visibleLayers.find(x => x.order > movedLayer.order) : visibleLayers.find(x => x.order === maxPosition)
      const up = visibleLayers.some(x => x.order < movedLayer.order) ? this.closestValue(visibleLayers, movedLayer.order) : undefined
      const down = visibleLayers.some(x => x.order > movedLayer.order) ? this.closestValue(visibleLayers, movedLayer.order) : undefined
      /*
      const up = visibleLayers.reduce((prev, cur) => {
        return Math.abs(cur.order - movedLayer.order) < Math.abs(prev.order - movedLayer.order) ? cur : prev
      })
      const down = visibleLayers.reduce((prev, cur) => {
        return Math.abs(cur.order - movedLayer.order) > Math.abs(prev.order - movedLayer.order) ? cur : prev
      })
      */
      // const up = visibleLayers.find(x => x.order < movedLayer.order)
      // const down = visibleLayers.find(x => x.order > movedLayer.order)
      if (typeof (up) === 'undefined') console.info('Acima não existe')
      if (typeof (down) === 'undefined') console.info('Abaixo não existe')
      if (up) console.warn(`${movedLayer.object.layer.cAlias} abaixo de ${up.object.layer.cAlias}`)
      if (down) console.warn(`${movedLayer.object.layer.cAlias} acima de ${down.object.layer.cAlias}`)
      if (typeof (up) !== 'undefined') {
        const dataViz = this.getDataViz('baseMap', up.object.layer.gdIdEvent)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? up.object.layer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : up.object.layer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${up.object.layer.gdIdEvent}`
        return {layer: up.object.layer, reverse: false, mapLayerId: beforeId, isCluster: isCluster}
      } else if (down !== undefined) {
        const dataViz = this.getDataViz('baseMap', down.object.layer.gdIdEvent)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? down.object.layer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : down.object.layer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${down.object.layer.gdIdEvent}`
        return {layer: down.object.layer, reverse: true, mapLayerId: beforeId, isCluster: isCluster}
      }
      return {layer: null, reverse: false, mapLayerId: '', isCluster: false}
    } catch (e) {
      console.log(e)
    }
    /*
    try {
      // const visibleLayers = projectLayers.filter(x => x.isVisible)
      let nearestLayer = {layer: null, reverse: false, mapLayerId: '', isCluster: false}
      let layers = []

      visibleLayers.forEach(function (layer) {
        // if (!layer.isVisible) return
        // if (layer.object.objectid === movedLayer.object.objectid) return
        // if (classType === 'fill' && layer.object.layer.jbData.config.datavis.type === 'cluster') return
        layers.push({
          objectid: layer.object.objectid,
          position: layer.object.position
        })
      })

      const maxPosition = Math.max.apply(Math, layers.map(function (o) {
        return o.position
      }))
      /!*
      const minPosition = Math.min.apply(Math, layers.map(function (o) {
        return o.position
      }))
      *!/

      // TODO Procurar acima/abaixo na lista de layer visiveis (index + 1) não faz sentido

      const searchUpOrder = (index + 1) === projectLayers.length ? maxPosition : movedLayer.order
      // const searchLowerOrder = index === 0 ? minPosition : movedLayer.order
      const x = (index + 1) === projectLayers.length ? visibleLayers.find(x => x.object.objectid !== movedLayer.object.objectid &&
        x.order === searchUpOrder) : visibleLayers.find(x => x.object.objectid !== movedLayer.object.objectid &&
        x.order < movedLayer.order)
      const y = visibleLayers.find(x => x.object.objectid !== movedLayer.object.objectid &&
        x.order > movedLayer.order)

      if (!x) console.info('Acima não existe')
      if (!y) console.info('Abaixo não existe')
      if (x) console.warn(`${movedLayer.object.layer.cAlias} abaixo de ${x.object.layer.cAlias}`)
      if (y) console.warn(`${movedLayer.object.layer.cAlias} acima de ${y.object.layer.cAlias}`)

      if (x !== undefined) {
        const rObject = projectLayers.find(l => l.object.objectid === x.object.objectid)
        const dataViz = this.getDataViz('baseMap', rObject.object.layer.gdIdEvent)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? rObject.object.layer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : rObject.object.layer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${rObject.object.layer.gdIdEvent}`
        nearestLayer.layer = rObject.object.layer
        nearestLayer.mapLayerId = beforeId
        nearestLayer.isCluster = isCluster
      } else if (y !== undefined) {
        const rObject = projectLayers.find(l => l.object.objectid === y.object.objectid)
        const dataViz = this.getDataViz('baseMap', rObject.object.layer.gdIdEvent)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? rObject.object.layer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : rObject.object.layer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${rObject.object.layer.gdIdEvent}`
        nearestLayer.layer = rObject.object.layer
        nearestLayer.mapLayerId = beforeId
        nearestLayer.reverse = true
        nearestLayer.isCluster = isCluster
      }
      return nearestLayer
    } catch (e) {
      console.log(e)
    }
    */
  }
  findNearestFrontierLayer (maplayers, index, classType) {
    if (!maplayers) throw new Error('Esperada uma coleção de layers')
    // if (!index) throw new Error("Esperado o índice do layer target")
    if (!classType) throw new Error('Esperado o tipo de classe do layer')
    if (!Array.isArray(maplayers)) throw new Error('Esperada uma coleção: maplayers')
    if (maplayers.length === 0) throw new Error('A coleção não pode estar vazia: maplayers')

    const movedLayer = maplayers[index]

    const visibleLayers = maplayers.filter(x => x.isVisible && x.mapLayer.objectId !== movedLayer.mapLayer.objectId)
    if (visibleLayers.length === 0) return {layer: null, reverse: false, mapLayerId: '', isCluster: false}

    try {
      const nearestValue = (input, lookup) => lookup.reduce((prev, curr) => (Math.abs(prev.position) > Math.abs(curr.position - input) ? curr.position - input : prev.position), Infinity) + input

      const up = visibleLayers.some(x => x.position < movedLayer.position) ? this.closestValue(visibleLayers, movedLayer.position) : undefined
      const down = visibleLayers.some(x => x.position > movedLayer.position) ? this.closestValue(visibleLayers, movedLayer.position) : undefined

      if (typeof (up) === 'undefined') console.info('Acima não existe')
      if (typeof (down) === 'undefined') console.info('Abaixo não existe')
      if (up) console.warn(`${movedLayer.name} abaixo de ${up.name}`)
      if (down) console.warn(`${movedLayer.name} acima de ${down.name}`)
      if (typeof (up) !== 'undefined') {
        const dataViz = this.getDataViz('baseMap', up.mapLayer.layerUid)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? up.mapLayer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : up.mapLayer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${up.mapLayer.parent}`
        return {layer: up.mapLayer.parent, reverse: false, mapLayerId: beforeId, isCluster: isCluster}
      } else if (down !== undefined) {
        const dataViz = this.getDataViz('baseMap', down.mapLayer.layerUid)
        const isCluster = dataViz === 'cluster'
        const beforeDataViz = isCluster ? down.mapLayer.jbData.config.datavis.type : MapConstants.GridTypes.includes(dataViz) ? 'fill' : down.mapLayer.jbData.config.datavis.native
        const beforeId = `${beforeDataViz}-${down.mapLayer.parent}`
        return {layer: down.mapLayer.parent, reverse: true, mapLayerId: beforeId, isCluster: isCluster}
      }
      return {layer: null, reverse: false, mapLayerId: '', isCluster: false}
    } catch (e) {
      console.log(e)
    }
  }
  getClusterCircleColor (initialColor, finalColor, bins) {
    return clusterStrategy.getClusterCircleColor(initialColor, finalColor, bins)
  }
  getClusterCircleRadius (bins) {
    return clusterStrategy.getClusterCircleRadius(bins)
  }
  getDataViz (mapKey, layerId) {
    if (!layerId) throw new Error('Esperado o identificador do layer')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    let mapData = this._restoreMap2(mapKey)
    const tags = [...MapConstants.GridTypes, ...MapConstants.LayerPrefixes]
    const map = mapData.mapObject
    let currentViz = null
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i]
      if (clusterStrategy.layerExists(map, `${tag}-${layerId}`) &&
        map.getLayoutProperty(`${tag}-${layerId}`, 'visibility') === 'visible') {
        currentViz = tag
        break
      }
    }
    return currentViz
  }
  getDefaultClusterStyle (bins) {
    return clusterStrategy.getDefaultClusterStyle(bins)
  }
  getLayer (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')
    let map = this.restoreMap(options.mapKey)
    return map.getLayer(options.layerId)
  }
  getLayerType (options) {
    const map = this.restoreMap(options.mapKey)
    return clusterStrategy.getLayerType(map, options.layerId)
  }
  getLayoutProperty (options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')
    if (!R.hasIn('key', options)) throw new Error('Esperado o nome da propriedade: key')
    let map = this.restoreMap(options.mapKey)
    let l = map.getLayer(options.layerId)
    if (l) {
      let x = map.getLayoutProperty(options.layerId, options.key)
      return x || 'visible'
    }
    return null
  }
  getMapLayerId (layerId, dataviz = 'cluster') {
    return [
      `${dataviz}-${layerId}`
    ]
    /*
    if (dataviz === 'cluster') {
      return [
        `cluster-${layerId}`,
        `label-${layerId}`,
        `symbol-${layerId}`
      ]
    } else {
      return [
        `${dataviz}-${layerId}`
      ]
    }
    */
  }
  getPaintProperty (options) {
    // mapKey, layerId, key, value
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')
    if (!R.hasIn('key', options)) throw new Error('Esperado o nome da propriedade: key')
    let map = this.restoreMap(options.mapKey)
    if (map.getLayer(options.layerId) != null) { return map.getPaintProperty(options.layerId, options.key) }
  }
  isEnabled (options) {
    let layer = this.getLayer(options)
    return (layer !== null)
  }
  layerZoomIsOutOfRange (options) {
    try {
      if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
      if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')()
      if (!R.hasIn('layerId', options)) throw new Error('Esperado o identificador do layer: layerId')()

      let map = this.restoreMap(options.mapKey)
      let layer = map.getLayer(options.layerId)
      options.minzoom = layer.minzoom
      const currentZoom = Math.round(map.getZoom())
      return (currentZoom < layer.minzoom)
    } catch (e) {
      console.log(e)
    }
  }
  moveLayer (mapKey, layerId, beforeId) {
    if (!layerId) throw new Error('Esperado o identificador do layer')
    if (!beforeId) throw new Error('Esperado o identificador do layer target')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    if (!R.is(String, beforeId)) throw new Error('Esperada uma String: beforeId')
    const map = this.restoreMap(mapKey)
    const x = map.getLayer(layerId)
    const y = map.getLayer(beforeId)
    if (x !== undefined && y !== undefined) { map.moveLayer(layerId, beforeId) }
  }
  zoomIsOutOfRange (options) {
    try {
      if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
      if (!R.hasIn('mapKey', options)) throw new new Error('Esperado o identificador do mapa: mapKey')()
      let map = this.restoreMap(options.mapKey)
      let style = options.datavis.style
      const currentZoom = Math.round(map.getZoom())
      return (currentZoom < style.minzoom)
    } catch (e) {
      console.log(e)
    }
  }
  querySourceFeatures (options = {}) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('sourceId', options)) throw new Error('Esperado o identificador do source: sourceId')
    if (!R.hasIn('sourceLayer', options)) throw new Error('Esperado o identificador so sourceLayer: sourceLayer')
    const map = this.restoreMap(options.mapKey)
    const features = map.querySourceFeatures(options.sourceId, {
      sourceLayer: options.sourceLayer,
      filter: options.filter || null
    })
    return features
  }
  queryRenderedFeatures (options = {}) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    if (!R.hasIn('mapKey', options)) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!R.hasIn('layers', options) || !Array.isArray(options.layers)) throw new Error('Esperada a coleção layers')
    const map = this.restoreMap(options.mapKey)
    const features = map.queryRenderedFeatures({layers: options.layers})
    return features
  }
  removeCluster (mapKey, layerId) {
    if (!layerId) throw new Error('Esperado o identificador do layer')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    let map = this._restoreMap2(mapKey).mapObject
    const layers = [
      `cluster-${layerId}`,
      `label-${layerId}`,
      `symbol-${layerId}`
    ]
    layers.forEach(function (layer) {
      if (map.getLayer(layer)) { map.removeLayer(layer) }
    })
    if (map.getSource(`source-cluster-${layerId}`)) { map.removeSource(`source-cluster-${layerId}`) }
  }
  removeLayer (mapKey, layerId) {
    if (!layerId) throw new Error('Esperado o identificador do layer')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    let mapData = this._restoreMap2(mapKey)

    clusterStrategy.removeLayer(mapData.mapKey, mapData.mapObject, layerId)
  }
  removeLayer2 (mapKey, layerId) {
    if (!layerId) throw new Error('Esperado o identificador do layer')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    let map = this._restoreMap2(mapKey).mapObject

    try {
      if (map.getLayer(layerId)) { map.removeLayer(layerId) }
      if (map.getSource(`source-${layerId}`)) { map.removeSource(`source-${layerId}`) }
    } catch (e) {
      console.log(`Erro ao remover o layer: ${layerId}`)
    }
  }
  removeFeatureState (options = {}) {
    if (typeof options.layerId === 'undefined') throw new Error("Esperado o parâmetro 'layerId'")
    if (typeof options.resourceType === 'undefined') throw new Error("Esperado o parâmetro 'resourceType'")
    const map = this.restoreMap('')
    const mapLayer = map.getLayer(`${options.resourceType}-${options.layerId}`)
    if (mapLayer) {
      map.removeFeatureState({
        source: mapLayer.source,
        sourceLayer: options.layerId
      })
    }
  }
  setFeatureState (options = {}) {
    if (typeof options.layerId === 'undefined') throw new Error("Esperado o parâmetro 'layerId'")
    if (!Array.isArray(options.data)) throw new Error("O parâmetro 'data' deve ser um array")
    if (typeof options.column === 'undefined') throw new Error("Esperado o parâmetro 'column'")
    if (typeof options.key === 'undefined') throw new Error("Esperada a coluna relacional: 'key'")

    try {
      const map = this.restoreMap(options.mapKey)
      const mapLayer = map.getLayer(`${options.resourceType}-${options.layerId}`)
      if (mapLayer) {
        let exitLoop = false

        for (let i = 0; i < options.data.length; i++) {
          if (exitLoop) break
          const row = options.data[i]
          let values = {}
          values[options.column] = row[options.column]
          try {
            map.setFeatureState({
              id: row[options.key],
              source: mapLayer.source,
              sourceLayer: options.sourceLayer
            }, values)
          } catch (e) {
            console.log(e)
            exitLoop = true
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  setFilter (mapKey, layerId, filter) {
    // region Validation
    if (!mapKey) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!layerId) throw new Error('Esperado o identificador do layer: layerId')
    if (!R.is(String, mapKey)) throw new Error('Esperada uma String: mapKey')
    if (!R.is(String, layerId)) throw new Error('Esperada uma String: layerId')
    if (!Array.isArray(filter) && filter !== null && typeof (filter) !== 'undefined') throw new TypeError(`Tipo inesparado para filter: ${typeof (filter)}`)
    // endregion
    const map = this.restoreMap(mapKey)
    const layer = map.getLayer(layerId)
    if (layer) {
      map.setFilter(layerId, filter)
    }
  }
  setLayerZoomRange (mapKey, layerId, minzoom = 0, maxzoom = 24) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa: mapKey')
    if (!layerId) throw new Error('Esperado o identificador do layer: layerId')
    try {
      let map = this.restoreMap(mapKey)
      const x = map.getLayer(layerId)
      if (x !== undefined) { map.setLayerZoomRange(layerId, minzoom, maxzoom) }
    } catch (e) {
      console.log(e)
    }
  }
  sourceReload (mapKey, sourceId) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa')
    if (!sourceId) throw new Error('Esperado o identificador do source')
    if (!R.is(String, sourceId)) throw new Error('Esperada uma String: sourceId')
    let map = this._restoreMap2(mapKey).mapObject

    try {
      const source = map.getSource(sourceId)
      if (source) {
        source.setTiles(source.tiles)
        /*
        source.setSourceProperty(() => {
          console.info(`Source ${sourceId} updated`)
        })
        */
      }
    } catch (e) {
      console.log(`Erro ao atualizar o source: ${sourceId}`)
    }
  }
  flyTo (mapKey) {
    try {
      let map = this.restoreMap(mapKey)
      map.flyTo({center: this.getCenter(mapKey)})
    } catch (e) {
      console.log(e)
    }
  }
  moveTo (map, coord) {
    console.log('Move to Feature')
    try {
      map.flyTo({
        center: [
          coord.lat,
          coord.long
        ],

        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      })
    } catch (e) {
      console.log(e)
    }
  }
  flyTo2 (map, coord, zoom = 9) {
    try {
      map.flyTo({
        center: [
          coord.lat,
          coord.long
        ],
        zoom: zoom,
        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      })
    } catch (e) {
      console.log(e)
    }
  }
  flyTo3 (mapKey, center, zoom = 9) {
    try {
      const map = this.restoreMap(mapKey)
      map.flyTo({
        center: center,
        zoom: zoom,
        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      })
    } catch (e) {
      console.log(e)
    }
  }
  fitBounds (map, coord) {
    try {
      map.fitBounds({
        center: coord,
        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      })
    } catch (e) {
      console.log(e)
    }
  }
  fitBounds2 (mapKey, bbox) {
    try {
      let map = this.restoreMap(mapKey)
      map.fitBounds(bbox, {
        padding: 50,
        duration: 1000
      })
    } catch (e) {
      console.log(e)
    }
  }
  getBBoxToArray (mapKey) {
    let map = this.restoreMap(mapKey)
    var bounds = map.getBounds()
    var bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
    return bbox
  }
  getCenter (mapKey) {
    let map = this.restoreMap(mapKey)
    return map.getCenter()
  }
  getStyle (mapKey = 'baseMap') {
    let map = this.restoreMap(mapKey)
    return map.getStyle()
  }
  getZoom (mapKey, round = true) {
    let map = this.restoreMap(mapKey)
    return round ? Math.floor(map.getZoom()) : map.getZoom()
  }
  /**
   * Add a map to collection
   * @param mapKey {string} Identificador do mapa na coleção
   * @param map {Object} Instância do mapa
   */
  addMap (mapKey, map, isDefault = false) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa')
    if (!R.is(String, mapKey)) throw new Error('Esperada uma String: mapKey')
    if (!map) throw new Error('Esperada a instância do mapa')
    if (!R.is(Object, map)) throw new Error('Esperado um Object: map')
    let maps = Vue.prototype.mapStore || []
    // if (!R.is(Array, maps)) Vue.prototype.mapStore = [];
    if (this._getMapIndex(mapKey) !== -1) {
      // throw new Error(`Já existe um mapa com esta chave na coleção: "${mapKey}"`);
      console.warn(`Já existe um mapa com esta chave na coleção: "${mapKey}"`)
      return
    }
    if (isDefault && this._getDefaultMap() !== -1) {
      // throw new Error(`Já existe um mapa default na coleção: "${isDefault}"`);
      console.warn(`Já existe um mapa default na coleção: "${isDefault}"`)
      return
    }
    maps.push({mapKey: mapKey, mapObject: map, isDefault: isDefault})
    Vue.prototype.mapStore = maps
  }

  /**
   * Delete a map from collection
   * @param mapKey {string} Identificador do mapa na coleção
   */
  deleteMap (mapKey) {
    try {
      let mapData = this._restoreMap2(mapKey)
      let mapIndex = this._getMapIndex(mapKey)
      clusterStrategy.cleanMap(mapData.mapObject)
      Vue.prototype.mapStore.splice(mapIndex, 1)
      /* if (!mapData.isDefault) {
        clusterStrategy.cleanMap(mapData.mapObject);
        Vue.prototype.mapStore.splice(mapIndex, 1);
      } */
      return true
    } catch (e) {
      console.log(e)
    }
    return false
  }

  /**
   * Get the default map into collection
   */
  _getDefaultMap () {
    // if (!R.is(Array, Vue.prototype.mapStore)) new Error("Coleção de mapas não inicializada");
    let maps = Vue.prototype.mapStore || []
    const mapIndex = maps.findIndex(m => m.isDefault)
    return mapIndex
  }

  /**
   * Get a map index into collection
   * @param mapKey {string} Identificador do mapa na coleção
   */
  _getMapIndex (mapKey) {
    if (!mapKey) throw new Error('Esperado o identificador do mapa')
    if (!R.is(String, mapKey)) throw new Error('Esperada uma String: mapKey')
    let maps = Vue.prototype.mapStore || []
    // if (!R.is(Array, Vue.prototype.mapStore))new Error("Coleção de mapas não inicializada");
    return maps.findIndex(m => m.mapKey === mapKey)
  }

  /**
   * Restore map state
   * @param mapKey {string} Identificador do mapa na coleção
   */
  restoreMap (mapKey) {
    let mapData = this._restoreMap2(mapKey)
    return mapData.mapObject
  }

  _restoreMap2 (mapKey) {
    let mapIndex = 0
    let maps = Vue.prototype.mapStore || []
    if (maps.length === 0) throw new Error('Coleção de mapas não inicializada')

    if (R.isEmpty(mapKey)) { mapIndex = this._getDefaultMap() } else { mapIndex = this._getMapIndex(mapKey) }

    if (mapIndex === -1) throw new Error(`Mapa não encontrado: "${mapKey}"`)
    return maps[mapIndex]
  }

  /**
   * Toogle visualization of the data
   * @param mapKey {string} Identificador do mapa na coleção
   * @param view {string} Identificador do tipo de visão (cluster, heatmap, etc)
   * @param layer {string} Identificador do layer
   */
  toogleDataViz (mapKey, view, layer) {
    let map = this.restoreMap(mapKey)
    clusterStrategy.toogleDataViz(map, view, layer)
  }

  /**
   * Toogle layer visibility
   * @param mapKey {string} Identificador do mapa na coleção
   * @param layerId {string} Identificador do layer
   */
  toogleVisibility (mapKey, layerId, state) {
    let map = this.restoreMap(mapKey)
    clusterStrategy.toogleVisibility(map, layerId, state)
  }

  redraw (layerId) {
    let map = this.restoreMap('')
    const layer = map.getLayer(`fill-${layerId}`)
    if (layer !== null) {
      const source = map.getSource(layer.source)
      source.tiles.forEach(function (tileUrl, index) {
        source.tiles[index] = `${tileUrl}&update=${Math.random()}`
      })
      // map.triggerRepaint()
    }
  }
}

const instance = new MapActions()
Object.freeze(instance)
export default instance
